import { useLocation } from "react-router-dom";
import { useState } from "react";
import Button from "../../components/button";
import styles from "./styles.module.css";
import NavItem from "./item";
import MobileNavigation from "./mobile-navigation";

export const MainNavigation = ({
  currentUser,
  showAdminBoard,
  showOpBoard,
  logOut,
}) => {
  const location = useLocation();
  const [hoveredMenu, setHoveredMenu] = useState(null);

  // Helper to check if a route is active
  const isActive = (path) => {
    if (location.pathname === path) return true;
    // For paths with children, check if current path starts with it
    // But make sure we don't match partial segments (e.g., /admin shouldn't match /admin/parameters)
    if (location.pathname.startsWith(path + "/")) return true;
    return false;
  };

  // Helper to check if admin exact match (don't match /admin/parameters)
  const isAdminExact = () => {
    return location.pathname === "/admin";
  };

  const parametersSubmenu = showOpBoard
    ? [
        { label: "Parámetros Last Price", path: "/admin/parameters/lastprice" },
        {
          label: "Parámetros FastMarket",
          path: "/admin/parameters/fastmarket",
        },
        { label: "Calcular Parámetros", path: "/admin/parameters/calc" },
        {
          label: "Editar Parámetros Precio Último",
          path: "/admin/parameters/edit/lastprice",
        },
        { label: "Peajes", path: "/admin/parameters/tolls" },
      ]
    : [];

  const complianceSubmenu = showOpBoard
    ? [
        { label: "Informe de Cumplimiento", path: "/compliance/report" },
        {
          label: "Mantenimiento de Creadores de Mercado",
          path: "/compliance/mmconditions",
        },
      ]
    : [];

  return (
    currentUser && (
      <nav className={styles.nav}>
        {/* Mobile Navigation */}
        <div className={styles.mobileOnly}>
          <MobileNavigation
            showAdminBoard={showAdminBoard}
            showOpBoard={showOpBoard}
            logOut={logOut}
            parametersSubmenu={parametersSubmenu}
            complianceSubmenu={complianceSubmenu}
            isActive={isActive}
            isAdminExact={isAdminExact}
          />
        </div>

        {/* Desktop menu */}
        <div className={styles.menuContainer}>
          <ul className={styles.menuList}>
            {showOpBoard && (
              <NavItem
                label="Parámetros"
                path="/admin/parameters/lastprice"
                submenuKey="parameters"
                children={parametersSubmenu}
                location={location}
                hoveredMenu={hoveredMenu}
                setHoveredMenu={setHoveredMenu}
                isActive={isActive}
              />
            )}

            {showOpBoard && (
              <NavItem
                label="Last Price"
                path="/last"
                location={location}
                hoveredMenu={hoveredMenu}
                setHoveredMenu={setHoveredMenu}
                isActive={isActive}
              />
            )}

            <NavItem
              label="Fast Market"
              path="/fast"
              location={location}
              hoveredMenu={hoveredMenu}
              setHoveredMenu={setHoveredMenu}
              isActive={isActive}
            />

            {showOpBoard && (
              <NavItem
                label="Cumplimiento"
                path="/compliance/report"
                submenuKey="compliance"
                children={complianceSubmenu}
                location={location}
                hoveredMenu={hoveredMenu}
                setHoveredMenu={setHoveredMenu}
                isActive={isActive}
              />
            )}

            {showAdminBoard && (
              <NavItem
                label="Logs"
                path="/logs"
                exactMatch={true}
                location={location}
                hoveredMenu={hoveredMenu}
                setHoveredMenu={setHoveredMenu}
                isActive={isActive}
              />
            )}

            {showAdminBoard && (
              <NavItem
                label="Gestión de Usuarios"
                path="/admin"
                exactMatch={true}
                location={location}
                hoveredMenu={hoveredMenu}
                setHoveredMenu={setHoveredMenu}
                isActive={isActive}
              />
            )}
          </ul>
        </div>

        <div className={styles.logoutContainer}>
          <Button onClick={logOut} variant="ghost" size="small">
            Cerrar Sesión
          </Button>
        </div>
      </nav>
    )
  );
};
